import script from "./FormParceriaExterna.vue?vue&type=script&setup=true&lang=js"
export * from "./FormParceriaExterna.vue?vue&type=script&setup=true&lang=js"

import "./FormParceriaExterna.vue?vue&type=style&index=0&id=14ab172b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14ab172b"]])

export default __exports__